import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { DAYS_PT, dayIndex, fmtDM, addDays, MK_STATUS, mondayOf } from "@/lib/marketing";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, CircleNotch, ClockCounterClockwise, Sparkle } from "@phosphor-icons/react";
import { toast } from "sonner";

const DOT = { rascunho: "bg-slate-400", aprovado: "bg-blue-500", publicado: "bg-emerald-500" };

function WeekRow({ w }) {
  const current = w.monday === mondayOf();
  return (
    <div className="stagger-item rounded-xl border border-border bg-card p-4" data-testid={`mk-history-week-${w.monday}`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className="font-display font-bold">Semana de {fmtDM(w.monday)} a {fmtDM(addDays(w.monday, 6))}/{w.monday.slice(0, 4)}</span>
          {current && <Badge>Atual</Badge>}
          {w.generation?.status === "done" && <Sparkle size={14} weight="fill" className="text-primary" title="Gerado com IA" />}
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {Object.entries(MK_STATUS).map(([k, v]) => (
            <Badge key={k} variant="outline" className={`${v.cls} text-[11px]`} data-testid={`mk-history-${w.monday}-${k}`}>{w.counts[k]} {v.label}</Badge>
          ))}
          <Button size="sm" variant="outline" className="rounded-full" asChild data-testid={`mk-history-open-${w.monday}`}>
            <Link to={`/marketing?week=${w.monday}`}>Abrir</Link>
          </Button>
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {w.items.map((i) => (
          <span key={i.id} className="flex items-center gap-1.5 rounded-full bg-secondary px-2.5 py-1 text-[11px]" title={i.headline || i.theme}>
            <span className={`h-2 w-2 rounded-full ${DOT[i.status]}`} />
            {DAYS_PT[dayIndex(i.day)].slice(0, 3)} · {i.type === "post" ? "Post" : "Story"}{i.theme ? ` · ${i.theme}` : ""}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function MarketingHistory() {
  const [weeks, setWeeks] = useState(null);
  useEffect(() => { api.get("/marketing/history").then((r) => setWeeks(r.data.weeks)).catch((e) => toast.error(apiError(e))); }, []);
  return (
    <div className="space-y-5" data-testid="marketing-history-page">
      <div className="flex items-center gap-3">
        <Button variant="outline" size="icon" className="rounded-full" asChild><Link to="/marketing"><ArrowLeft size={18} /></Link></Button>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Marketing</p>
          <h1 className="font-display text-3xl font-extrabold tracking-tight">Histórico</h1>
        </div>
      </div>
      {!weeks ? <div className="flex h-40 items-center justify-center"><CircleNotch size={24} className="animate-spin text-primary" /></div>
        : weeks.length === 0 ? (
          <div className="flex flex-col items-center gap-2 rounded-xl border border-border bg-card py-14 text-center" data-testid="mk-history-empty">
            <ClockCounterClockwise size={36} className="text-muted-foreground" /><p className="text-muted-foreground">Ainda não há semanas planeadas.</p>
          </div>
        ) : <div className="space-y-3">{weeks.map((w) => <WeekRow key={w.monday} w={w} />)}</div>}
    </div>
  );
}
